import React, { Component } from 'react';
import SingleBotcard from './SingleBotcard';

require('./botcatalog.css');

//Required for Firebase Database and Firebase Storage: 
var firebase = require('firebase');
var db = firebase.firestore();

var Modal = require('boron/OutlineModal');
var style = {
    modalStyle: {
        width: 'auto',
        height: '15px',
    }
};

class Botcatalog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allApps: [],
            dataRecieved: false
        };
        this.goToAddBotPage = this.goToAddBotPage.bind(this);
    }

    contactUs = () => {
        let nameInput = document.getElementById('nameInput').value,
            businessNameInput = document.getElementById('businessNameInput').value,
            contactNumberInput = document.getElementById('contactNumberInput').value,
            emailInput = document.getElementById('emailInput').value,
            businessWebsiteInput = document.getElementById('businessWebsiteInput').value,
            summaryArea = document.getElementById('summaryArea').value;
        let referThis = this;

        /*const sgEmail = require('@sendgrid/mail');
        sgEmail.setApiKey('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');
        const welcomeTempId = '8ba11742-333b-4412-8c41-c549e85bc056'; */


        if (nameInput === "" || contactNumberInput === "" || emailInput === "") {
            this.refs.denyModal.show();
        } else {
            let emailRef = db.collection('contactUsEmails');
            emailRef.doc(emailInput).set({
                email: emailInput,
                businessName: businessNameInput,
                contactNumber: contactNumberInput,
                name: nameInput,
                businessWebsite: businessWebsiteInput,
                shortIntroduction: summaryArea
            }).then(function () {
                //Success submitting the information. 
                referThis.refs.approvedModal.show();
            }).catch(function (error) {
                document.getElementById('errorArea').innerText = 'Error submitting information. Please try again later.';
                console.error(error);
            });
        }
    }

    componentWillMount() {
        //Load the bots from the database. 
        var commonCatalogPath = db.collection('applications'), referThis = this;
        var counter = 0;

        console.log("Getting all apps info!");
        commonCatalogPath.get().then(function (allApps) {
            var allAppsArray = [];

            console.log("Going into the ForEach statement");
            allApps.forEach(function (eachApp) {
                var eachAppDetails = {};
                counter += 1;

                console.log("App Counter: " + counter);
                console.log("App Info: " + eachApp.data().appName);

                //Set each app details into this object
                eachAppDetails.appName = eachApp.data().appName;
                eachAppDetails.appType = eachApp.data().appType;
                eachAppDetails.appDbLink = eachApp.data().dbPath;
                eachAppDetails.appStorageLink = eachApp.data().filesPath;
                eachAppDetails.appUserEmail = eachApp.data().userEmail;
                eachAppDetails.counter = counter;


                allAppsArray.push(eachAppDetails);
            });

            referThis.setState({
                allApps: allAppsArray
            });

            /* console.log("All Apps Array: " + referThis.state.allApps.length);
             var allAppsTest = referThis.state.allApps;
             for (var i = 0; i < allAppsTest.length; i++) {
                 console.log(allAppsTest[i]);
             } */

        }).catch(err => {
            //There was an error retrieving data. 
            document.getElementById('messagePlace').innerText = 'There was an error getting data: ' + err.code;
        }).then(() => {
            //All the data has been received. 
            console.log("All the data has been recieved!");
            referThis.setState({
                dataRecieved: true
            });

            console.log("Data Recieved: " + referThis.state.dataRecieved);
        });
    }

    goToAddBotPage() {
        document.getElementById('messagePlace').innerText = 'The feature is under maintenance. Sorry for the inconvenience.';
        //window.location.replace('/AddBot');
    }

    render() {
        while (!this.state.dataRecieved) {
            console.log("Data Recieved: " + this.state.dataRecieved);
            return (
                <div className="loadingDiv text-center">
                    <br />
                    <h3><i className="fab fa-pied-piper-alt" id='spinner' ></i></h3>
                    <br />
                </div>

            );
        }
        var allAppsArray = this.state.allApps;
        if (allAppsArray.length === 0) {
            //There are currently no applications available....
            console.log("There are no apps!");
            return (
                <div className="comingsoon">
                    <section className="text-center twoMidSections">
                        <div className="card comingsoonContactCard">
                            <div className="card-body">
                                <h1 className="card-title">Coming Soon....</h1>
                                <div className="card-text">
                                    Each business is unique.<br />
                                    Please fill out the form to contact us about custom pricing and to discuss your business needs.
                                </div>
                                <hr />
                                <form style={{ paddingRight: '30px', paddingLeft: '30px' }}>
                                    <input type="text" className="form-control cominginput" id="nameInput" placeholder="Full Name" required />
                                    <br />
                                    <input type="text" className="form-control cominginput" id="businessNameInput" placeholder="Business Name" required /><br />
                                    <input type="tel" className="form-control cominginput" id="contactNumberInput" placeholder="Contact Number" required /><br />
                                    <input type="email" className="form-control cominginput" id="emailInput" placeholder="Email Address" required /><br />
                                    <input type="url" className="form-control cominginput" id="businessWebsiteInput" placeholder="Website URL" required /><br />
                                    <textarea className='form-control cominginput' id='summaryArea' rows='3' placeholder="Short Introduction" required></textarea><br />
                                </form>
                                <button className="btn" id='contactUsButton'
                                    onClick={() => this.contactUs()}
                                >Contact Us</button>
                                <br />
                                <small id='errorArea'> </small>
                            </div>
                        </div>
                    </section>
                    <Modal ref='denyModal' modalStyle={style.modalStyle}>
                        <br />
                        <h3>Please fill out the required information</h3>
                        <br />
                    </Modal>
                    <Modal ref='approvedModal' modalStyle={style.modalStyle}>
                        <br />
                        <h3>Thank you! We will contact you as soon as possible!</h3>
                        <br />
                    </Modal>
                </div>
            );
        } else {
            return (
                <div>
                    <div className='container' id='card_catalog_div'>
                        <h3 className='text-center'>Solutions</h3>
                        <small id="messagePlace"></small>
                        <div className="bot_list_div">
                            <button type="button" className="btn" id='AddOwnBotButton' onClick={() => this.goToAddBotPage()}>
                                <i className="fas fa-plus-circle"></i> |
                                  Add Your Own App!
                            </button>
                            <div className="dropdown">
                                <button className="btn btn-primary dropdown-toggle" type="button" id="sortByButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Sort by
                                </button>
                                <div className="dropdown-menu">
                                    <button className="dropdown-item" type="button">Popular</button>
                                    <button className="dropdown-item" type="button">Newest</button>
                                    <button className="dropdown-item" type="button">Highest Rated</button>
                                </div>
                            </div>
                            <br />
                            <hr />
                            <div className="row bot_card_rows">
                                {
                                    allAppsArray.map((data, i) => <SingleBotcard {...data} key={data.counter + i + data.counter} />)
                                }
                            </div>
                        </div>
                    </div>
                </div >
            );
        }

    }
}

export default Botcatalog;


// WEBPACK FOOTER //
// ./src/BotCatalog/Botcatalog.js